import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../modules/auth/hooks/useAuth";
import Loader from "../components/common/Loader";

const RoleRoute = ({ allowedRoles = [] }) => {
  const {
    user,
    isAuthenticated,
    loading,
  } = useAuth();

  const location = useLocation();

  /*
  |--------------------------------------------------------------------------
  | AUTH STATE LOADING
  |--------------------------------------------------------------------------
  */

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  /*
  |--------------------------------------------------------------------------
  | NOT AUTHENTICATED
  |--------------------------------------------------------------------------
  */

  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location,
        }}
      />
    );
  }

  /*
  |--------------------------------------------------------------------------
  | USER ROLES
  |--------------------------------------------------------------------------
  */

  const userRoles = Array.isArray(user.roles)
    ? user.roles
    : [];

  /*
  |--------------------------------------------------------------------------
  | ROLE CHECK
  |--------------------------------------------------------------------------
  */

  const hasPermission = allowedRoles.some((role) =>
    userRoles.includes(role)
  );

  /*
  |--------------------------------------------------------------------------
  | ACCESS DENIED
  |--------------------------------------------------------------------------
  */

  if (!hasPermission) {
    return <Navigate to="/users" replace />;
  }

  /*
  |--------------------------------------------------------------------------
  | AUTHORIZED
  |--------------------------------------------------------------------------
  */

  return <Outlet />;
};

export default RoleRoute;